import React from 'react'
import { TabbedForm, FormTab, TextInput } from 'react-admin'
import { CitiesSelect } from '../../components/custom'

const ClubForm = (props) => {
  return (
    <TabbedForm {...props} label='Создания клуба'>
      <FormTab label='Клуб'>
        <TextInput fullWidth={true} source='name' label='Название' />
        <TextInput fullWidth={true} source='manager' label='Контактное лицо' />
        <CitiesSelect />
        <TextInput fullWidth={true} source='address' label='Адрес' />
        <TextInput fullWidth={true} source='site' label='Сайт' />
        <TextInput fullWidth={true} source='phone' label='Телефон' />
      </FormTab>
      {/* может пригодиться 
      <FormTab label='Описание турнира'>
        <RichTextInput source='description' label='Описание' />
      </FormTab> */}
    </TabbedForm>
  )
}

export default ClubForm
